import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Input, Row, Table, Tag } from 'antd';
import { formatAddress } from '../ReusableComponent/Common';
import { baseUrl } from '../../common/constants';
import { toast } from 'react-toastify';
import styles from './search.module.scss'
import _axios from '../../utils/api/_axios';
const SearchDoctor = ({ setDoctorSelectValue, setOfficeSelectValue,setFormValues,formValues}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [users, setUsers] = useState([]);

  const fetchFilteredData = async () => {
    if (!searchQuery) {
      toast.error("Please enter a valid search query (e.g., name, address, or zip code) to find doctors.");
    } else {
      try {
        setIsLoading(true);
        const response = await _axios.get(`${baseUrl}/physician/search/${searchQuery}`, {
        });
        let doctors = response.data?.payload;
        setUsers(doctors);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    }
  };

  const resetSearchedData = () => {
    setUsers([]);
    setSearchQuery('');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      fetchFilteredData();
    }
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      render: (text, record, index) => index + 1,
      width:50
    },
    {
      title: 'first name',
      dataIndex: 'physicianFirstName',
      key: 'firstName',
    },
    {
      title: 'last name',
      dataIndex: 'physicianLastName',
      key: 'lastName',
    },
    // {
    //   title: 'Address',
    //   dataIndex: 'physicianAddress',
    //   key: 'address',
    //   responsive: ['sm'],
    // },
    // {
    //   title: 'City',
    //   dataIndex: 'physicianCity',
    //   key: 'city',  
    //   responsive: ['sm'],
    // },
    // {
    //   title: 'Zip',
    //   dataIndex: 'physicianZip',
    //   key: 'zip',
    //   responsive: ['sm'],
    // },
    {
      title: 'Email',
      dataIndex: 'physicianEmail',
      key: 'email',
      responsive: ['md'],
    },
    {
      title: 'Mobile',
      dataIndex: 'physicianPhone',
      key: 'mobile',
      responsive: ['lg'],
    },
        //     {
        //   title: 'Address',
        //   dataIndex: 'personal',
        //   key: 'address',
        //   render: (personal) => formatAddress(
        //     personal.address?.addressLine1,
        //     personal.address?.addressLine2,
        //     personal.address?.city,
        //     personal.address?.state,
        //     personal.address?.zip
        //   ),
        //   responsive: ['sm'], 
        // },
        // {
        //   title: 'Categories',
        //   dataIndex: 'categories',
        //   key: 'categories',
        //   render: (categories) => categories?.map((ele) => <Tag>{ele?.name}</Tag>),
        // },
        // {
        //   title: 'services',
        //   dataIndex: 'physicianServices',
        //   key: 'services',
        //   render: (physicianServices) => physicianServices?.map((service) => <Tag key={service}>{service}</Tag>)
        // },
  ];

  return (
    <>
      <Card size='small' className={styles.cardWrapper}>
      <Row gutter={16} className={styles.cardBodyWrapper}>
        <Col className={styles.columnsStyle} xs={24} sm={12} md={14} lg={14}>
          <Input
            placeholder="Search doctor by zip code, address, name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onPressEnter={handleKeyPress}
            size='middle'
          />
        </Col>
        <Col className={styles.columnsStyle} xs={24} sm={12} md={5} lg={5}>
          <Button size='middle' className='fullWidth' type="primary" onClick={fetchFilteredData}>Search</Button>
        </Col>
        <Col className={styles.columnsStyle} xs={24} sm={12} md={5} lg={5}>
          <Button size='middle' className='fullWidth' type="default" onClick={resetSearchedData}>Reset</Button>
        </Col>
      </Row>
      </Card>
      {
        users?.length > 0 ? 
        <Table
        columns={columns}
        dataSource={users}
        loading={isLoading}
        scroll={{ y: 240 }}
        pagination={{ pageSize: 5 }}
        onRow={(record) => ({
          onClick: async() => {
            const name = `${record.physicianFirstName} ${record?.physicianLastName}`;
            const response = await _axios.get(`${baseUrl}/hospitalPhysician/physician/${record?._id}`)
            const hospitals = response.data?.payload;
            setFormValues({...formValues , doctorId:record?._id, doctorName:name, offices: hospitals})
            setDoctorSelectValue(name)
            setOfficeSelectValue(hospitals[0]?.hospitalName)
          },
        })}
      />
      : null
      }
    </>
  );
};

export default SearchDoctor;
